module.exports = __webpack_public_path__ + "static/media/2-GJALTE.ea9bc7d3.mp3";